import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/confidence")({
  beforeLoad: () => {
    throw redirect({ to: "/confidence-check-for-kids", replace: true, statusCode: 301 });
  },
});
